var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteBgCp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.96875,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7086_76388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 24.9688V31.9688C31 32.234 30.8946 32.4883 30.7071 32.6759C30.5196 32.8634 30.2652 32.9688 30 32.9688H14C13.7348 32.9688 13.4804 32.8634 13.2929 32.6759C13.1054 32.4883 13 32.234 13 31.9688V24.9688C13.5304 24.9688 14.0391 24.758 14.4142 24.383C14.7893 24.0079 15 23.4992 15 22.9688C15 22.4383 14.7893 21.9296 14.4142 21.5545C14.0391 21.1795 13.5304 20.9688 13 20.9688V13.9688C13 13.7035 13.1054 13.4492 13.2929 13.2616C13.4804 13.0741 13.7348 12.9688 14 12.9688H30C30.2652 12.9688 30.5196 13.0741 30.7071 13.2616C30.8946 13.4492 31 13.7035 31 13.9688V20.9688C30.4696 20.9688 29.9609 21.1795 29.5858 21.5545C29.2107 21.9296 29 22.4383 29 22.9688C29 23.4992 29.2107 24.0079 29.5858 24.383C29.9609 24.758 30.4696 24.9688 31 24.9688ZM29 26.4338C28.3917 26.0828 27.8865 25.5777 27.5354 24.9694C27.1843 24.3611 26.9996 23.6711 27 22.9688C27 21.4888 27.804 20.1957 29 19.5037V14.9688H15V19.5037C16.196 20.1957 17 21.4888 17 22.9688C17 24.4487 16.196 25.7417 15 26.4338V30.9688H29V26.4338ZM19 16.9688H25V18.9688H19V16.9688ZM19 26.9688H25V28.9688H19V26.9688Z",
    fill: "#1C9FDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7086_76388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10.9688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBgCp);
export default __webpack_public_path__ + "static/media/whiteBgCp.5091b720d02dd7c8c33e687f5b790c5b.svg";
export { ForwardRef as ReactComponent };